/** Returns true when a keyboard event started inside user-editable text. */
export const isEditableKeyboardTarget = (
  target: EventTarget | null
): boolean => {
  if (!(target instanceof Element)) return false

  const editableTarget = target.closest(
    [
      'input',
      'textarea',
      'select',
      '[contenteditable]',
      '[role="textbox"]',
    ].join(',')
  )

  if (!editableTarget) return false
  if (!editableTarget.hasAttribute('contenteditable')) return true

  return editableTarget.getAttribute('contenteditable') !== 'false'
}
